import TAGGED from "../modules/tagged_content"

const [ w, d, content ] = [ window, document, 'works' ]

const init = () => {
  
}

const detail_init = async post_id => {
  let articles = await $.getArticles({ content })
  let categories = await $.getCategories({ content })
  let the_article = articles.filter( a => (a.id == post_id) ).shift()
  the_article.category = categories.filter( c => c.id == the_article.category )[0]

  // タグボックス
  let tags = keywords => {
    let html = ""
    if(!keywords || keywords.length == 0) return ''
    keywords.forEach( key => html += `<a href="/${content}/?mode=list&tag=${ encodeURI( key ) }" class="tag">${key}</a>` )
    return `<div class="${content}-detail__tags">${html}</div>`
  }
  $('.element_detail .entry').append( tags( the_article.keywords ) )

}


export default function WORKS () {
  TAGGED()
  $(() => {
    init()
    if( w.query_string('article') ) detail_init( w.query_string('article') )
  })
}